import { MiModal, MiStackedTypography } from "@miplatform/components";
import { Box } from "@mui/system";
import { useCreateBidContext } from "../CreateBidContext";
import { BID_STATUS, STEP } from "../constants";

export function ApproveModal({ open, closeModal, goBack }: ApproveModalProps) {
  const {
    form,
    communities,
    accounts,
    seriesGroups,
    setActiveStep,
    handleUpdateBidStatus,
  } = useCreateBidContext();
  const { watch, getValues } = form;
  const { name, series, communityId, builderId, seriesGroupId } = watch();

  const community = communities.find((c) => c.id === communityId);
  const customerName = accounts.find((a) => a.id === builderId)?.name;
  const seriesGroupName = seriesGroups.find(
    (group) => group.id === seriesGroupId
  )?.name;

  return (
    <MiModal
      open={open}
      title={`Approve ${name}`}
      description="Are you sure you want to approve this bid?"
      closeModal={closeModal}
      actions={[
        {
          title: "Cancel",
          variant: "text",
          color: "black",
          onClick: closeModal,
        },
        {
          title: "Edit Bid Details",
          variant: "outlined",
          onClick: () => {
            closeModal();
            setActiveStep(STEP.DETAILS);
          },
        },
        {
          title: "Approve Bid",
          variant: "contained",
          onClick: async () => {
            const data = getValues();
            const success = await handleUpdateBidStatus(
              data,
              BID_STATUS.APPROVED
            );
            if (success) {
              closeModal();
              goBack();
            }
          },
        },
      ]}
    >
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
        <MiStackedTypography
          title="Community"
          description={community?.name || "--"}
          style={{ width: "35%" }}
          boldDescription
        />
        <MiStackedTypography
          title="City"
          description={community?.city?.cityName || "--"}
          style={{ width: "35%" }}
          boldDescription
        />
        <MiStackedTypography
          title="Customer"
          description={customerName || "--"}
          style={{ width: "35%" }}
          boldDescription
        />
        <MiStackedTypography
          title="Series Group"
          description={seriesGroupName || "--"}
          style={{ width: "35%" }}
          boldDescription
        />
        <MiStackedTypography
          title="Series"
          description={series || "--"}
          style={{ width: "35%" }}
          boldDescription
        />
      </Box>
    </MiModal>
  );
}

interface ApproveModalProps {
  open: boolean;
  closeModal: () => void;
  goBack: () => void;
}
